import * as yup from 'yup';
import {
  STATUS_FAILED,
  STATUS_PENDING,
  STATUS_PROCESSED,
  STATUS_REVERSED,
  REASON_FRAUDULENT,
  REASON_DUPLICATE,
  REASON_NOT_GIVEN,
  REASON_OTHER,
  REASON_REQUESTED_BY_CUSTOMER
} from './helpers';
import {
  amountSchema,
  multiSelectValidation,
} from 'components/PaymentFilter/defaultFilters.schema';

export const FIELD_NAMES = {
  statusCheckbox: 'statusCheckbox',
  amountCheckbox: 'amountCheckbox',
  reasonCheckbox: 'reasonCheckbox',

  failed: STATUS_FAILED,
  pending: STATUS_PENDING,
  refunded: STATUS_PROCESSED,
  cancelled: STATUS_REVERSED,
  
  reasonRequestedByCustomer: REASON_REQUESTED_BY_CUSTOMER,
  reasonOther: REASON_OTHER,
  reasonNotGiven: REASON_NOT_GIVEN,
  reasonDuplicate: REASON_DUPLICATE,
  reasonFraudulent: REASON_FRAUDULENT,

  amount_filter: 'amount_filter',
  amount: 'amount',
};

export const defaultValues = (currentFilters) => {
  const statusFilters = new Set(currentFilters.status.split(','));
  const reasonFilters = new Set(currentFilters.reason.split(','));

  return {
    [FIELD_NAMES.statusCheckbox]: currentFilters.statusCheckbox && Boolean(currentFilters.status.length),
    [FIELD_NAMES.reasonCheckbox]: currentFilters.reasonCheckbox && Boolean(currentFilters.reason.length),
    status: {
      [FIELD_NAMES.failed]: statusFilters.has(FIELD_NAMES.failed),
      [FIELD_NAMES.pending]: statusFilters.has(FIELD_NAMES.pending),
      [FIELD_NAMES.refunded]: statusFilters.has(FIELD_NAMES.refunded),
      [FIELD_NAMES.cancelled]: statusFilters.has(FIELD_NAMES.cancelled)
    },
    reason: {
      [FIELD_NAMES.reasonRequestedByCustomer]: reasonFilters.has(FIELD_NAMES.reasonRequestedByCustomer),
      [FIELD_NAMES.reasonOther]: reasonFilters.has(FIELD_NAMES.reasonOther),
      [FIELD_NAMES.reasonNotGiven]: reasonFilters.has(FIELD_NAMES.reasonNotGiven),
      [FIELD_NAMES.reasonDuplicate]: reasonFilters.has(FIELD_NAMES.reasonDuplicate),
      [FIELD_NAMES.reasonFraudulent]: reasonFilters.has(FIELD_NAMES.reasonFraudulent),
    },
    [FIELD_NAMES.amountCheckbox]: !!currentFilters.amount,
    [FIELD_NAMES.amount_filter]: currentFilters.amount_filter,
    [FIELD_NAMES.amount]: currentFilters.amount,
  };
};

const statusValidation = multiSelectValidation(FIELD_NAMES.statusCheckbox);
const reasonValidation = multiSelectValidation(FIELD_NAMES.reasonCheckbox)

const schema = yup.object().shape({
  [FIELD_NAMES.failed]: statusValidation,
  [FIELD_NAMES.pending]: statusValidation,
  [FIELD_NAMES.refunded]: statusValidation,
  [FIELD_NAMES.cancelled]: statusValidation,
  [FIELD_NAMES.reasonDuplicate]: reasonValidation,
  [FIELD_NAMES.reasonFraudulent]: reasonValidation,
  [FIELD_NAMES.reasonRequestedByCustomer]: reasonValidation,
  [FIELD_NAMES.reasonNotGiven]: reasonValidation,
  [FIELD_NAMES.reasonOther]: reasonValidation,

  ...amountSchema,
});

export default schema;
